import React from "react";

function AddAdmin() {
  return (
    <div>
      addadmin page
      <p>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Magnam, quis
        ut at modi vel perspiciatis enim nam tenetur quia autem harum atque,
        placeat explicabo consequatur consequuntur, minima a molestias
        aspernatur!
      </p>
    </div>
  );
}

export default AddAdmin;
